"use strict";
/** @jsxRuntime classic */
/** @jsx jsx */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebshopHeader = void 0;
var react_1 = require("react");
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var hooks_1 = require("../../hooks");
var JangleLogo_1 = require("../../molecules/JangleLogo/JangleLogo");
var MobileNavigation_1 = require("../../molecules/MobileNavigation/MobileNavigation");
var RegularNavigation_1 = require("../../molecules/RegularNavigation/RegularNavigation");
var WebshopHeader = function (_a) {
    var menuItems = _a.menuItems, profileComponent = _a.profileComponent;
    var _b = hooks_1.useMenuState(), createToggleHandler = _b.createToggleHandler, isActive = _b.isActive, setItem = _b.setItem;
    var ref = react_1.useRef(null);
    hooks_1.useOutsideclick(ref, function () { return setItem(null); });
    hooks_1.useKeyDownHandler("Escape", function () { return setItem(null); });
    var Profile = profileComponent;
    return (theme_ui_1.jsx(theme_ui_1.Flex, { ref: ref, sx: {
            justifyContent: [
                "space-between",
                "space-between",
                "flex-start",
            ],
            backgroundColor: __1.theme.colors.blueishBlack,
        } },
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: { order: 1 } },
            theme_ui_1.jsx(JangleLogo_1.JangleLogo, null)),
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                order: [3, 3, 2],
                mr: [45, 45, 0],
                pl: [0, 0, __1.theme.space[1] + "px", 0],
            } },
            theme_ui_1.jsx(RegularNavigation_1.RegularNavigation, { menuItems: menuItems }),
            theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                    display: ["flex", "flex", "none"],
                    alignItems: "center",
                    ml: __1.theme.space[1] + "px",
                } },
                theme_ui_1.jsx(MobileNavigation_1.MobileNavigation, { menuItems: menuItems, toggleMenu: createToggleHandler("mobileNavigation"), isMenuOpen: isActive("mobileNavigation") }))),
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                ml: [25, 25, "auto"],
                mr: ["auto", "auto", 25, 25, 120, 270],
                order: [2, 2, 3],
            } }, Profile && react_1.cloneElement(Profile, { isMenuOpen: isActive("profileNavigation"), toggleMenu: createToggleHandler("profileNavigation") }))));
};
exports.WebshopHeader = WebshopHeader;
